// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b0bc0924","239":"4e0029ba","455":"f7e7b850"}[chunkId] + ".chunk.js";
};